import { consignmentStockApi } from "../services/consignmentStockApi";
import consignmentStockSlice from "../slices/consignmentStockSlice";

export const consignmentStockReducers = {
  [consignmentStockApi.reducerPath]: consignmentStockApi.reducer,
  consignmentStock: consignmentStockSlice,
};
